import * as React from 'react';

const SvgThreeStarDark = () => (
  <svg
    width="14"
    height="14"
    fill="none"
    version="1.1"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m11.454 5.0909 0.7955-1.75 1.75-0.79546-1.75-0.79545-0.7955-1.75-0.7954 1.75-1.75 0.79545 1.75 0.79546zm-4.7727 0.31818-1.5909-3.5-1.5909 3.5-3.5 1.5909 3.5 1.5909 1.5909 3.5 1.5909-3.5 3.5-1.5909zm4.7727 3.5-0.7954 1.75-1.75 0.7954 1.75 0.7955 0.7954 1.75 0.7955-1.75 1.75-0.7955-1.75-0.7954z"
      fill="url(#paint0_linear_647_7750)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_647_7750"
        x1="3.8636"
        x2="18.182"
        y1="3"
        y2="3"
        gradientTransform="translate(-1,-3)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6268FF" offset=".255" />
        <stop stopColor="#3BA7FF" offset="1" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgThreeStarDark;